import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useAssignRoom } from './use-assign-room';

import type { QueryKey } from '@tanstack/react-query';
import type { IPatientAssignStateChange } from 'infrastructure/interfaces';
import type { RpmOverviewDashboardResponse } from '../rpm/overview-dashboard';

export const useUpdateAssigneeOverviewDashboard = (queryKey: QueryKey) => {
  const queryClient = useQueryClient();

  const callBack = useCallback((data: IPatientAssignStateChange) => {
    queryClient.setQueryData<RpmOverviewDashboardResponse>(
      queryKey,
      (oldData) => {
        if (!oldData) return oldData;

        const newData = structuredClone(oldData);

        newData.data.forEach((item) => {
          if (item.guid === data.patientGuid) {
            item.assignee = data.assignee;
          }
        });

        return newData;
      },
    );
  }, []);

  useAssignRoom(callBack);
};
